import { defineStore } from 'pinia'

export const userStore = defineStore('user', {
  state: () => ({
    partnerId: null,
    sessionId: null,
    firstName: null,
    lastName: null,
    loginName: null,
    phone: null,
    mobile: null,
    expireDate: null,
    contracts: []
  }),
  getters: {
    expireDateObject: state => {
      return typeof state.expireDate !== 'object' ? new Date(typeof state.expireDate === 'number' ? state.expireDate * 1000 : state.expireDate) : state.expireDate
    },
    isAuthenticated: state => {
      return !(!state.partnerId || !state.expireDate || new Date() > state.expireDateObject)
    }
  },
  persist: true
})
